import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import ArtworkGrid from "./ArtworkGrid";
import "../css/Gallery.css"
import GalleryHeader from "./GalleryHeader";
import Footer from "./Footer";

function shuffleArray(array) {
    const newArr = [...array]; // copy array to avoid mutating original
    for (let i = newArr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
    }
    return newArr;
}


export default function YearGallery({ artworks }) {
    const { year } = useParams();

    const yearArt = useMemo(() => {
        return shuffleArray(artworks).filter(a => a.year === year);
    }, [artworks, year]);

    return (
        <div className="gallery">
            <GalleryHeader title={year}/>
            <ArtworkGrid artworks={yearArt} rowsize={500} />
            <Footer/>
        </div>
    );
}

